import PropTypes from 'prop-types';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { toSentenceCase } from '../../../utils';

import DropDownMenu from '../../DropDownMenu';

const ApprovalButtons = (props) => {
  const theme = useTheme();

  const { approvalStatus, onPostStatusUpdate } = props;

  const grey = theme.palette.grey[400];
  const secondary = theme.palette.secondary.main;
  const success = theme.palette.success.main;

  const isPending = approvalStatus === 'pending';
  const isApproved = approvalStatus === 'approved';
  const isAutoApproval = approvalStatus === 'auto';

  const color = isPending
    ? grey
    : isApproved || isAutoApproval
    ? success
    : secondary;

  const title = (
    <Typography color={theme.palette.common.white}>
      {toSentenceCase(approvalStatus)}
    </Typography>
  );

  const approvalStatusOptions = [
    {
      label: 'Pending',
      onClick: () => onPostStatusUpdate('pending'),
      color: grey,
    },
    {
      label: 'Approve',
      onClick: () => onPostStatusUpdate('approved'),
      color: success,
    },
    {
      label: 'Decline',
      onClick: () => onPostStatusUpdate('declined'),
      color: secondary,
    },
  ];

  return (
    <DropDownMenu
      title={title}
      items={approvalStatusOptions}
      color={color}
      disabled={isAutoApproval}
      isButton
    />
  );
};

ApprovalButtons.propTypes = {
  approvalStatus: PropTypes.string.isRequired,
  onPostStatusUpdate: PropTypes.func.isRequired,
};

export default ApprovalButtons;
